<template>
   <div id="scene-03" class="canvas" :style="zone9.style">
      <div id="8000a">
        <!-- This is the text from Scene 2 Zone 8 -->
        <h1>{{zone8.val}}</h1>
      </div>

      <!-- Video *** Use the player from Zach's files ***-->
      <div class="main-wrapper">
         
         <div class="zone-09">
            <div class="video-wrapper">
               <!-- This is the title of the video asset -->
               <p class="video-title">{{zone10.title}}</p>
               <!-- Use poster for the alternate thumbnail; 
               use controlsList to hide the fullscreen and download buttons -->
               <ul id="main_list" v-if="zone12">
                  <!-- <video id="video" name="media" controls controlsList="nodownload"
                        :poster="this.GALLERY_HOST + '/' + zone10.thumb" :src="this.GALLERY_HOST + '/' + zone10.val" type="video/mp4">
                  </video>
                  <video id="video" name="media" controls controlsList="nodownload" :poster="this.GALLERY_HOST + '/' + zone10.thumb" 
                        :src="this.GALLERY_HOST + '/' + zone10.val" type="video/mp4">
                  </video> -->
                  <div v-for="(video, index) in zone12.val"
                        :key="index" class="thumb-wrapper">
                     <img :src="GALLERY_HOST + '/' + zone12.thumb[index]" :data-val="video">
                  </div>
               </ul>

               <div class="video-inner-wrapper">
                  <!-- This is the title of the video asset -->
                  <!-- <p>{{zone10.title}}</p> -->
                  <!-- Use poster for the alternate thumbnail; 
                  use controlsList to hide the fullscreen and download buttons -->
                  <div id="jquery_jplayer_3" class="jp-jplayer"></div>
                     <div id="jp_container_3" class="jp-audio" role="application" aria-label="media player">
                        <div class="jp-padding">
                           <div class="jp-type-single">
                              <button id="play">
                                 <img src="./assets/img/bttn-play.svg">
                              </button>
                              <button id="pause">
                                 <img src="./assets/img/bttn-pause.svg">
                              </button>
                              <div class="progress">
                                 <div class="seek-wrapper">
                                 <div id="seek_bar">
                                    <div id="play_bar">
                                       <div class="jp-ball"></div>
                                    </div>
                                 </div>
                                 </div>
                              </div>
                              <span id="duration"></span>
                              <img id="volume_icon" src="./assets/img/icon-volume.svg">
                              <div id="volume_bar">
                                 <div id="volume_value"></div>
                              </div>
                              <img id="close_btn_3" class="close close-btn-red" src="./assets/img/bttn-close.svg" @click.stop="$emit('close')">
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
         </div>
         

         <!-- <slick
            ref="slick"
            :options="slickOptions">
            <div v-for="(image, index) in asset.val"
               :key="index"
               class="main-img-wrapper">
               <img :src="this.GALLERY_HOST + '/'+ image" :alt="'image'+index" :data-large="this.GALLERY_HOST + '/'+ image" data-description="" />
            </div>
         </slick> -->

         <div class="carousel-btns" v-if="zone12">
            <div class="prev-wrapper carousel-btn-wrapper">
               <img class="prev" @click="handleSwitch" src="./assets/img/bttn-left.svg">
            </div>

            <div class="next-wrapper carousel-btn-wrapper">
               <img class="next" @click="handleSwitch" src="./assets/img/bttn-right.svg">
            </div>
         </div>

         <div class="text-container">
            <span class="image-title"></span>
         </div>

          
      </div>



      <!-- <div class="zone-09"> -->
       
      <!-- </div> -->

      <!-- Map -->
      <div id="zone-11">
        <div class="map-wrapper">
          <img :src="this.GALLERY_HOST + '/' + zone11.val" id="11000">
        </div>
      </div>
    </div>
</template>

<script>
import Slick from 'vue-slick';

export default {
   props: {
      zone8: {},
      zone9: {},
      zone10: {},
      zone11: {},
      zone12: {},
   },

   mounted() {
      let video;
      if (this.zone12) {
         video = this.GALLERY_HOST + '/' + this.zone12.val[0];
      } else {
         video = this.GALLERY_HOST + '/' + this.zone10.val;
      }
      let self = this;
      $(function() {
         "use strict";

         if (self.zone12) {
            $('.video-title').text(self.zone12.title[0]);
         } else {
            $('.video-title').text(self.zone10.title[0]);
         }

         $("#jquery_jplayer_3").jPlayer({
            ready: function() {
               $(this).jPlayer( "setMedia", {
                  m4v: video
               });

               $(this).jPlayer('play');
            },
            timeupdate: function(event) {
               $("#jp_container_3 .jp-ball").css("left",event.jPlayer.status.currentPercentAbsolute + "%");
            },
            cssSelectorAncestor: "#jp_container_3",
            cssSelector: {
               title: "#title",
               play: "#play",
               pause: "#pause",
               currentTime: "#currentTime",
               duration: "#duration",
               seekBar: "#seek_bar",
               playBar: "#play_bar",
               volumeBar: "#volume_bar",
               volumeBarValue: "#volume_value"
            },
            swfPath: "/js",
            supplied: "m4v, ogv",
            useStateClassSkin: true,
            autoBlur: false,
            smoothPlayBar: true,
            keyEnabled: true,
            remainingDuration: true,
            toggleDuration: true,
            // size: {
            //    width: 1055,
            //    height: 565
            // },
            size: {
               width: 688,
               height: 450
            },
            ended: function() {
               // showScene2();
               if (self.zone12) {
                  if (self.zone10.val.length > 1) {
                     $('.next').trigger("click");
                  }
               } else {
                  self.showScene2();
               }

            }
         });

         if (self.zone12) {
            $('#main_list').slick({
               cssEase: 'linear',
               slidesToShow: 1,
               slidesToScroll: 1,
               arrows: true,
               vertical: false,
               adaptiveWidth: true,
               centerMode: true,
               prevArrow: $('.prev'),
               nextArrow: $('.next'),
            });

            // $('#main_list').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            //    $('#main_list .slick-slide[data-slick-index="' + currentSlide + '"] .thumb-wrapper img').css('margin', '0 auto');
            // });

            $('#main_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
               var vid = $('#main_list .slick-current img').attr('data-val');
               self.switchVideo(vid);
               $('.video-title').text(self.zone10.title[currentSlide]);
               // $('#main_list .slick-slide[data-slick-index="' + currentSlide + '"] .thumb-wrapper img').css('display', 'none');
            });

            $('.thumb-wrapper img')
                  .each(function() {
                     var $this = $(this);
                     if ($this.width() > $this.height()) {
                        $this.addClass('landscape');
                     } else {
                        $this.addClass('portrait');
                     }
                  });

         }

      });
   },

   methods: {
      handleSwitch() {
         $('.jp-jplayer').css('visibility', 'hidden');
      },

      switchVideo(video) {
         let self = this;
         $(function() {
            "use strict";

            $("#jquery_jplayer_3").jPlayer("setMedia", {
               m4v: self.GALLERY_HOST + '/' + video
            });

            $('.jp-jplayer').css('visibility', 'visible');

            $("#jquery_jplayer_3").jPlayer('play');
         });
      }
   }
}
</script>

<style lang="scss" scoped>
/* SCENE THREE */
.canvas#scene-03 {
  /* background-image: url('../images/SCENE3_Map-Video_BG.png'); */
  background-repeat: no-repeat;
  background-position: 0px 100%;
  color: #000;

  position: absolute;
   z-index: 2;
   top: 0;
   left: 0;
   height: 100%;
   width: 1080px;
}

#scene-03 .zone-08 {
  margin: 0;
  /* background-image: url('../assets/img/graphic-logo-small.png'); */
  background-repeat: no-repeat;
  background-position: 0 0;
}
#scene-03 h1 {
  padding: 32px 0 32px 2%;
  font-size: 36px;
  font-weight: 500;
  line-height: 36px;
  color: white;
//   text-transform: uppercase;
}
#scene-03 .zone-08,
#scene-03 .zone-10 {
  color: inherit;
  text-transform: uppercase;
}
/* Map and hours */
.zone-10 h2 {
  padding: 64px 0 11px 61px;
  font-weight: 700;
  font-size: 60px;
}
.zone-10 .map-wrapper {
  width: 1080px;
  height: 1031px;
  margin-left: auto;
}
/* Zone 9 is the Video container */
.zone-09 {
  /* background-color: #000; */
}
/* Need final height of the video wrapper from Karen */
#scene-03 .video-wrapper {
  width: 1055px;
  height: 600px;
  background: black;
  position: relative;
  margin: 0 auto;
}
.video-wrapper p {
  padding: 12px;
  font-size: 25px;
  color: #fff;
}
.video-wrapper .close {
  right: 37px !important;
}
.video-inner-wrapper {
   position:absolute;
   top:62px;
   width:100%;
   padding-top: 40px;
   // left: 66px;
}
.main-wrapper {
   width: 1055px;
   height: 670px;
   background-color: black;
   margin: 0 auto;
}
#zone-10 {
  margin-top: 100px;
}

.map-wrapper {
  text-align: center;
}

.player-container {
   position: absolute;
   z-index: 2;
   margin: auto;
   top: 0;
   bottom: 0;
   right: 0;
   left: 0;
   width:1000px;
   height: 1500px;
   overflow: hidden;

   color: white;
}

#jquery_jplayer_1,
#jquery_jplayer_3 {
   background: #000;
}
.jp-jplayer {
   margin: 0 auto;

   video {
      margin-top: 40px;
   }
}
audio{
  width: 100%;
}

.header-container {
  padding-top: 20px;
  padding-left: 20px;
}

.header-title {
  font-size: 22px;
}

.audio-controls {
  position: relative;
}

.close-btn {
	position: absolute;
	right: 13px;
	top: 17px;
}

/**Player**/

#jp_container_1 img,
#jp_container_3 img {
  width: 15px;
  height: 15px;
}

#jp_container_3 {
   margin-top: 55px;
}

.jp-play {
  background: white;
}

#play,
#pause {
  margin-right: 7px;
}

.button-container {
  display: flex;
  position: relative;
}

.jp-audio button {
  padding: 0;
  border: none;
  background: black;
}

.jp-audio {
  width: 100%;
  background: black;
  padding:0;
}

.jp-padding {
  padding: 20px;
}

.jp-type-single {
  display: flex;
  align-items: center;

  .progress {
     margin-bottom: 0px !important;
  }
}

.jp-ball {
  position: absolute;
  z-index: 999;
  border-radius: 30px;
  left: 0;
  width: 1em;
  height: 1em;
  margin: -0.2em 0px 0px -0.5em;
  width: 14px;
  height: 14px;

  width: 0.9333em;
  height: 0.9333em;
  margin: -0.175em 0px 0px -0.466em;
  background-color: #fff;
  padding: 0px;
  -webkit-transition: -webkit-transform 0.15s ease-in-out;
  transition: transform 0.15s ease-in-out;
}

.progress {
   padding: 3px 0;
   background: transparent !important;
   margin-bottom: 0 !important;
}

.seek-wrapper {
  width: 600px;
  margin: 0 7px;
}

#seek_bar {
  height: 7px;
  margin-top: 5px;
  background: gray;
  position:relative;
}

#play_bar {
  height: 7px;
  background: #2797d9;
}

#duration {
  font-size: 12px;
  margin-right: 25px;
  color: white;
}

#volume_icon {
  margin-right: 7px;
}

#volume_bar {
  height: 7px;
  width: 150px;
  background: gray;
  margin-right: 75px;
}

#volume_value {
  background: #2797d9;
  height: 7px;
}

#seek_bar,
#play_bar,
#volume_value,
#volume_bar {
  border-radius: 5px;
}

.close-btn-red {
  width: 33px !important;
  height: 33px !important;
  position: absolute;
  right: 7px;
}

.scene3-background-image {
   position: absolute;
   top: 0;
   left: 0;
}

#zone-11 {
   position: relative;
   margin-top: 110px;
}

#8000a {
   position: relative;
}

.carousel-btns img {
   width: 70px;
   height: 61px;
}

.carousel-btn-wrapper {
   position: absolute;
   top: 415px;
}

.prev-wrapper {
   left: 13px;
}

.next-wrapper {
   right: 13px;
}

#main_list {
   padding-top: 100px;
   height: 544px;
   width: 1055px;
}

.thumb-wrapper {
   // width: 335px;

   img {
      // max-width: 20%;
      // // margin-top: 106px;
      margin-left: -70px;
      // max-height: 100%;

      &.portrait {
         width: 20%;
         height: auto;
         max-height: 100%;
      }

      &.landscape {
         width: 58%;
         height: auto;
         max-height: 100%;
      }
   }
}

.slick-active {
   img {
      margin: 0 auto;
   }
}

</style>
